var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "billing-exclusion-flag",
      attrs: { label: _vm.label, prop: _vm.prop, rules: _vm.rules }
    },
    [
      _c(
        "el-select",
        {
          attrs: {
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            autofocus: _vm.autofocus,
            clearable: _vm.clearable,
            filterable: false,
            "filter-method": _vm.filter
          },
          model: {
            value: _vm.date,
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        },
        _vm._l(_vm.options, function(item) {
          return _c(
            "el-option",
            {
              key: item.value,
              attrs: { label: item.label, value: item.value }
            },
            [
              _c("span", { staticStyle: { float: "left" } }, [
                _vm._v(_vm._s(item.label))
              ])
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }